<template>
  <div class="policy-regulations">
    <associationNotice @changePage="changePage" @click="toDetails" :list="list" :total="total"></associationNotice>
  </div>
</template>

<script>
import associationNotice from '@/components/associationNotice.vue';
import {findRoute} from '@/utils/routerHelper.js'
import {dynamics} from '@/api/api.js';
export default {
  components:{
    associationNotice
  },
  data(){
    return {
      list:[
        {
          title:'社会工作法规汇编',
          date:'2024-01-15',
          files:[
            {
              name:'社会工作法规汇编.pdf',
              size:'2.5MB',
              url:'https://example.com/law1.pdf'
            }
          ]
        },
        {
          title:'社会工作服务机构管理办法',
          date:'2024-02-20',
          files:[
            {
              name:'管理办法.pdf',
              size:'1.8MB',
              url:'https://example.com/law2.pdf'
            }
          ]
        },
        {
          title:'社会工作者职业资格管理办法',
          date:'2024-03-10',
          files:[
            {
              name:'资格管理办法.pdf',
              size:'1.2MB',
              url:'https://example.com/law3.pdf'
            }
          ]
        },
        {
          title:'社会工作服务规范',
          date:'2024-04-05',
          files:[
            {
              name:'服务规范.pdf',
              size:'2.0MB',
              url:'https://example.com/law4.pdf'
            }
          ]
        }
      ],
      total: 4,
      currentPage: 1
    }
  },
  created(){
    this.getList()
  },
  methods:{
    getList(){
      dynamics({
        current:this.currentPage,
        size:10,
        type:18
      }).then(res=>{
        if(res.data.code==200){
          this.total=res.data.data.total
          this.list=res.data.data.records.map(v=>{
            let dateData=this.getDate(v.createTime)
            v.date=dateData.newDates,
            v.day=dateData.day
            return v
          })
        }
      })
    },
    toDetails(data){
       this.$router.push(
        { path: '/associationNews/details',query: { id: data.id } }
        )
        let routerList=[]
        let routers = ['/resourceCenter','resourceCenterPolicyRegulations', '/associationNews/details'];
        for (let i = 0; i < routers.length; i++) {
          let routerData=findRoute(this.$router.options.routes, routers[i])
          routerList.push(routerData)
        }
        this.$store.commit('routerData/changeRouterList',routerList)
      // this.$router.push({
      //   path: '/resourceCenter/details',
      //   query: {
      //     title: data.title,
      //     date: data.date,
      //     files: JSON.stringify(data.files || [])
      //   }
      // })
    },
    changePage(page){
      this.currentPage = page
      this.getList()
    },
     getDate(dateString){
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return {
        day,
        newDates:year+'-'+(month<10?('0'+month):month)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.policy-regulations {
  width: 100%;
}
</style>
